import { useEffect, useRef } from "react";

const globalCache: any = {};
export default function useCache() {
  const cacheIdRef = useRef(String(Math.random()));
  const cacheId = cacheIdRef.current;

  if (!globalCache[cacheId]) {
    globalCache[cacheId] = {};
  }

  const thisCache = globalCache[cacheId];

  useEffect(() => {
    return () => {
      delete globalCache[cacheId];
    };
  }, [cacheId]);

  return {
    cache: thisCache,
    replaceCache: (value: Record<string, any>) => {
      globalCache[cacheId] = value;
    },
    getUpdatedValues: (newValues: Record<string, any>) => {
      const updatedValues: any = {};
      Object.keys(newValues).forEach(name => {
        if (thisCache[name] !== newValues[name]) {
          updatedValues[name] = newValues[name];
        }
      });

      return updatedValues;
    }
  };
}
